import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Returns date as 2022-03-01
 * This method will use the system timezone which could be different
 * in the browser, making a difference of a day.
 */
export function dateToDateString(date: Date): string {
  return dayjs(date).format('YYYY-MM-DD');
}

/**
 * Returns date as 2022-03-01
 * This method will use the system timezone which could be different
 * in the browser, making a difference of a day.
 */
export function dateToAmericanDateString(date: Date): string {
  return dayjs(date).format('MM/DD/YYYY');
}

/**
 * Returns date as iso format (2022-03-01)
 * for the specified timezone
 */
export function dateToDateStringWithZone(date: Date, timezone = 'UTC'): string {
  return dayjs(date).tz(timezone).format('YYYY-MM-DD');
}

/**
 * Returns date as (8/3/2023)
 * for the specified timezone
 */
export function formatConversationDate(date: Date, timezone = 'UTC'): string {
  try {
    return dayjs(date).tz(timezone).format('M/D/YYYY');
  } catch (error) {
    return date.toISOString();
  }
}

/**
 * Returns date as "June 7, 2023"
 * for the specified timezone
 */
export function dateToLongFormatWithZone(date: Date, timezone = 'UTC'): string {
  return dayjs(date).tz(timezone).format('MMMM D, YYYY');
}

/**
 * Returns date as "27 Oct"
 * for the specified timezone
 */
export function dateToDayMonthFormatWithZone(
  date: Date,
  timezone = 'UTC',
): string {
  return dayjs(date).tz(timezone).format('D MMM');
}

/**
 * Returns date as (5:44 pm EDT)
 * for the specified timezone
 */
export function formatConversationTime(date: Date, timezone = 'UTC'): string {
  try {
    const dateWithoutSeconds = date.toLocaleTimeString('en-US', {
      timeZone: timezone,
      timeZoneName: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });

    // Split the formatted string to separate the time and the timezone abbreviation
    const parts = dateWithoutSeconds.split(' ');
    const timePart = parts.slice(0, -1).join(' '); // Join everything except the last part
    const timeZonePart = parts[parts.length - 1].toUpperCase(); // Convert the timezone part to uppercase

    return `${timePart.toLowerCase()} ${timeZonePart}`;
  } catch (error) {
    return date.toISOString();
  }
}
